import { LicenseInfo } from '@mui/x-data-grid-pro';

export const initializeMuiXPro = () => {
  const licenseKey = import.meta.env.VITE_APP_MUI_X_PRO_LICENSE;

  if (licenseKey) {
    LicenseInfo.setLicenseKey(licenseKey);
  }
};
